export const initialChecklist = {
  company_name: '',
  vat_number: '',
  order_reference: '',
  accounting_email: '',
  billing_address: '',
  contact_email: '',
  work_address: '',
  parking_option: '',
  contact_person: '',
  contact_phone: '',
  work_accessibility: '',
  access_from_time: '',
  key_location_code: '',
  base_type: '',
  base_type_other: '',
  screed_type: '',
  collector_location: '',
  floor_level: '',
  pipe_spacing: '',
  vent_type: '',
  heat_loss_type: '',
  floor_covering: '',
  collector_type: '',
  pipe_type: '',
  pipe_diameter: '',
  unheated_storage: false,
  unheated_kitchen_island: false,
  unheated_kitchen_cabinets: false,
  unheated_bathroom_shower: false,
  unheated_garage: false,
  unheated_plan_marked: false,
  non_standard_dispersion: false,
  non_standard_expansion: false,
  tape_foil: false,
  self_adhesive_edge: false,
  special_expansion_joints: false,
  collector_position: '',
  manometer_left: false,
  electricity_present: '',
  electricity_where: '',
  wall_drilling: '',
  vertical_transport: '',
  insulation_date: '',
  acoustic_mat_date: '',
  screed_date: '',
  system_1_type: '',
  system_1_desc: '',
  system_2_type: '',
  system_2_desc: '',
  system_3_type: '',
  system_3_desc: '',
  extra_information: '',
  status: '1'
};

export const requiredChecklistFields = [
  'company_name',
  'vat_number',
  'order_reference',
  'accounting_email',
  'billing_address',
  'contact_email',
  'work_address',
  'contact_person',
  'contact_phone',
  'collector_location',
  'floor_level',
  'pipe_spacing',
  'vent_type',
  'heat_loss_type',
  'floor_covering',
  'collector_type',
  'pipe_type',
  'pipe_diameter',
  'status'
];
